/* @flow */
import moment from 'moment';

import ParamsLink from 'components/Links/ParamsLink';

import Td from 'components/UIKit/Table/Td';
import TrLink from '../TrLink';

export default function DynamicEntityRow({
  children,
  IconComponent,
  router,
}: any): React.Element {
  const newQuery = { did: children.id };
  const isActiveItem = children.id
    && (router.location.query.did === children.id);

  return (
    <TrLink
      isActiveItem={isActiveItem}
      linkId={children.id}
      router={router}
      >
      <Td>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <IconComponent style={{ marginRight: '.5rem' }} />
          {isActiveItem ? children.submitter_id : (
            <ParamsLink customDataTestID="text-submitter-id" query={newQuery}>
              {children.submitter_id}
            </ParamsLink>
          )}
        </div>
      </Td>

      <Td customDataTestID="text-type" style={{ textTransform: 'capitalize' }}>
        {children.type}
      </Td>

      <Td customDataTestID="text-experimental-strategy" style={{ textTransform: 'capitalize' }}>
        {children.experimental_strategy}
      </Td>

      <Td customDataTestID="text-case-id" style={{ textTransform: 'capitalize' }}>
        {(children._related_cases || []).map(x => x.submitter_id).join(', ')}
      </Td>

      <Td customDataTestID="text-state" style={{ textTransform: 'capitalize' }}>
        {children.state}
      </Td>

      <Td customDataTestID="text-file-state" style={{ textTransform: 'capitalize' }}>
        {children.file_state}
      </Td>

      <Td customDataTestID="text-last-updated">
        {moment(children.updated_datetime).format('ll')}
      </Td>
    </TrLink>
  );
}
